import { configQueryData } from 'query-data';
export const {
  QueryDataProvider,
  useSelectQueryData,
  useSelectApolloQueryData,
  registerApolloQueryToCache,
  registerQueryToCache,
  registerMutationToCache,
  cacheQuery,
  cacheMutation
} = configQueryData();